window.config = {
  webPath: '',
  
  itradeAPI: location.origin,
  itradePath: '',

  MDSStreamingAPI: 'ws://ttl2aacloud01.tx-tech.com/streaming',
  MDSSnapshotAPI: 'ws://ttl2aacloud01.tx-tech.com/snapshot',
  MDSOthersAPI: 'ws://ttl2aacloud01.tx-tech.com/info',
  MDSPath: 'pubsub',
  
  MDSEntityKey: 'SCB',
  MDSSuperkey: 'shcb2txtech01keyencrypt20key0315',

  winvestorAPI: location.origin,
  winvestorPath: 'ttl/api',

  winvestorDeviceID: 'itrade7.5-web-ttl',
  winvestorConsumerId: 'winvestor_ttl_broker',
  winvestorConsumerSecret: '$2y$10$i2c7LGyreYVUYjvQg1huUupnLufpzTugDyelyaowsZGe36j8N5KFi',

  // en_US 英 zh_CN 简 zh_TW 繁
  defaultLanguage: 'zh_CN', 
  
  companyOptions: {
    riskDisclosure: {
      zh_CN: 'http://18.167.144.171:28083/ttl/web/zh-hans/basic_page/order/risk_disclosure.html',
      en_US: 'http://18.167.144.171:28083/ttl/web/en/basic_page/order/risk_disclosure.html',
      zh_TW: 'http://18.167.144.171:28083/ttl/web/zh-hant/basic_page/order/risk_disclosure.html'
    },
    importantNotice:{
      zh_CN: 'http://18.167.144.171:28083/ttl/web/zh-hans/basic_page/order/important_notice.html',
      en_US: 'http://18.167.144.171:28083/ttl/web/en/basic_page/order/important_notice.html',
      zh_TW: 'http://18.167.144.171:28083/ttl/web/zh-hant/basic_page/order/important_notice.html'
    }
  },
}